/**
 * Session times are stored wall-clock-as-UTC (VN local time labeled Z, e.g. 9:00 VN → 09:00:00Z).
 * To compare a stored startAt against "now", use this VN-wall-clock now, NOT Date.now() (real UTC),
 * which for UTC+7 is 7h behind the stored wall-clock. TODO: make the offset a per-org setting.
 */
export const VN_UTC_OFFSET_MS = 7 * 60 * 60 * 1000;
